import KSUID from 'ksuid';

export const createHash = () => {
    const ksuidFromDate = KSUID.randomSync();
    return ksuidFromDate.string;
};
